// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3046": "b63cef43738d","3586": "5f8cb0c9f0c2","3922": "57d5af9355c6","6863": "454c9f289029","8357": "dd422574e14d",}[chunkId] + ".css"
}